module.exports = { "default": require("core-js/library/fn/object/entries"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/core-js/object/entries.js
// module id = 311
// module chunks = 0